(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coffee-finder-quiz"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-coffee-finder]');

    roots.forEach((root) => {
      const panels = Array.from(root.querySelectorAll('[data-step-panel]'));
      const form = root.querySelector('[data-coffee-finder-form]');
      const results = root.querySelector('[data-results]');
      const error = root.querySelector('[data-step-error]');
      const status = root.querySelector('[data-step-status]');
      const progress = root.querySelector('[data-step-progress]');
      const back = root.querySelector('[data-back]');
      const next = root.querySelector('[data-next]');
      const reset = root.querySelector('[data-reset]');
      let currentStep = 0;
      const answers = {};
      const trackingTag = '_Recommended by: Coffee Finder Quiz';
      const products = {
        breakfast: {
          title: root.dataset.productBreakfastTitle,
          url: root.dataset.productBreakfastUrl
        },
        cowboy: {
          title: root.dataset.productCowboyTitle,
          url: root.dataset.productCowboyUrl
        },
        duo: {
          title: root.dataset.productDuoTitle,
          url: root.dataset.productDuoUrl
        },
        mushroom: {
          title: root.dataset.productMushroomTitle,
          url: root.dataset.productMushroomUrl
        },
        sample: {
          title: root.dataset.productSampleTitle,
          url: root.dataset.productSampleUrl
        },
        daily: {
          title: root.dataset.productDailyTitle,
          url: root.dataset.productDailyUrl
        }
      };

      const updateStep = () => {
        panels.forEach((panel, index) => {
          const isCurrent = index === currentStep;
          panel.hidden = !isCurrent;
          panel.setAttribute('aria-hidden', String(!isCurrent));
        });
        status.textContent = `Step ${currentStep + 1} of ${panels.length}`;
        progress.value = currentStep + 1;
        back.hidden = currentStep === 0;
        next.textContent = currentStep === panels.length - 1 ? 'See my recommendations' : 'Next';
        error.hidden = true;
      };

      const recordCurrentAnswer = () => {
        const selected = panels[currentStep].querySelector('input:checked');
        if (!selected) {
          error.hidden = false;
          const firstChoice = panels[currentStep].querySelector('input');
          if (firstChoice) firstChoice.focus();
          return false;
        }
        answers[selected.name] = selected.value;
        error.hidden = true;
        return true;
      };

      const trackedUrl = (url) => {
        const destination = new URL(url, window.location.origin);
        destination.searchParams.set('recommendation', trackingTag);
        return `${destination.pathname}${destination.search}${destination.hash}`;
      };

      const getRecommendations = () => {
        const brew = answers.brew_method;
        const flavor = answers.flavor_vibe;
        const roast = answers.roast_preference;
        const format = answers.quantity_format;
        const scores = {
          breakfast: 1 + (brew === 'pour_over' ? 2 : 0) + (flavor === 'smooth' ? 3 : 0) + (roast === 'medium' ? 4 : 0) + (format === 'everyday' ? 2 : 0),
          cowboy: 1 + (brew === 'french_press' || brew === 'espresso' ? 2 : 0) + (flavor === 'bold' ? 3 : 0) + (roast === 'dark' ? 4 : 0) + (format === 'everyday' ? 1 : 0),
          duo: 1 + (brew === 'french_press' ? 1 : 0) + (flavor === 'bold' ? 1 : 0) + (roast === 'dark' ? 1 : 0) + (format === 'duo' ? 8 : 0),
          mushroom: 1 + (brew === 'pour_over' ? 1 : 0) + (flavor === 'explore' ? 5 : 0) + (roast === 'medium' ? 2 : 0) + (format === 'everyday' ? 1 : 0),
          sample: 1 + (flavor === 'explore' ? 2 : 0) + (roast === 'light' ? 2 : 0) + (format === 'sample' ? 8 : 0),
          daily: 1 + (brew === 'drip' ? 1 : 0) + (flavor === 'sweet' ? 2 : 0) + (format === 'gift' ? 8 : 0)
        };

        return Object.keys(scores)
          .filter((key) => products[key].url)
          .sort((left, right) => scores[right] - scores[left])
          .slice(0, 2)
          .map((key) => products[key]);
      };

      const showRecommendations = () => {
        const recommendations = getRecommendations();
        const cards = Array.from(root.querySelectorAll('[data-result-link]'));
        const titles = Array.from(root.querySelectorAll('[data-result-title]'));

        recommendations.forEach((product, index) => {
          if (!cards[index] || !titles[index]) return;
          cards[index].href = trackedUrl(product.url);
          titles[index].textContent = product.title;
        });

        form.hidden = true;
        results.hidden = false;
        status.textContent = 'Recommendations ready';
        results.focus();
      };

      next.addEventListener('click', () => {
        if (!recordCurrentAnswer()) return;
        if (currentStep === panels.length - 1) {
          showRecommendations();
          return;
        }
        currentStep += 1;
        updateStep();
      });

      back.addEventListener('click', () => {
        if (currentStep === 0) return;
        currentStep -= 1;
        updateStep();
      });

      reset.addEventListener('click', () => {
        form.reset();
        Object.keys(answers).forEach((key) => delete answers[key]);
        currentStep = 0;
        results.hidden = true;
        form.hidden = false;
        updateStep();
      });

      form.addEventListener('change', () => {
        error.hidden = true;
      });

      updateStep();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-duo"] && !Shopify.designMode) return;
  try {
    
  const mountRescueRoasterDuo = (root) => {
    if (!root || root.dataset.duoReady === 'true') return;

    const variantData = root.querySelector('[data-duo-variant-data]');
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const variantInput = form?.querySelector('input[name="id"]');
    const addButton = root.querySelector('[ref="addToCartButton"]');
    const priceElement = root.querySelector('[data-duo-price]');
    const selectionStatus = root.querySelector('[data-duo-selection-status]');

    if (!variantData || !form || !variantInput || !addButton || !priceElement) return;

    let variants;

    try {
      variants = JSON.parse(variantData.textContent);
    } catch (error) {
      return;
    }

    if (!Array.isArray(variants) || variants.length === 0) return;

    const getSelection = (option) => root.querySelector(`input[data-duo-option="${option}"]:checked`)?.value;

    const syncVariant = () => {
      const selectionOne = getSelection('one');
      const selectionTwo = getSelection('two');
      const selectedVariant = variants.find(
        (variant) => variant.one === selectionOne && variant.two === selectionTwo,
      );

      if (!selectedVariant) {
        variantInput.value = '';
        addButton.disabled = true;
        priceElement.textContent = '';
        if (selectionStatus) selectionStatus.textContent = 'This combination is currently unavailable.';
        return;
      }

      variantInput.value = selectedVariant.id;
      priceElement.textContent = selectedVariant.price;
      addButton.disabled = !selectedVariant.available;

      if (selectionStatus) {
        selectionStatus.textContent = selectedVariant.available
          ? `${selectedVariant.title} selected. Ready to add to cart.`
          : `${selectedVariant.title} is currently unavailable.`;
      }
    };

    root.querySelectorAll('input[data-duo-option]').forEach((input) => {
      input.addEventListener('change', syncVariant);
    });

    root.dataset.duoReady = 'true';
    syncVariant();
  };

  const mountRescueRoasterDuoSections = (scope = document) => {
    if (scope.matches?.('[data-rescue-roaster-duo]')) {
      mountRescueRoasterDuo(scope);
      return;
    }

    scope.querySelectorAll?.('[data-rescue-roaster-duo]').forEach(mountRescueRoasterDuo);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountRescueRoasterDuoSections(), { once: true });
  } else {
    mountRescueRoasterDuoSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    mountRescueRoasterDuoSections(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
